/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleblurbackground3Inputs */

const en_refineexampleblurbackground3 = /** @type {(inputs: Refineexampleblurbackground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blur background`)
};

const de_refineexampleblurbackground3 = /** @type {(inputs: Refineexampleblurbackground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund unscharf`)
};

/**
* | output |
* | --- |
* | "Blur background" |
*
* @param {Refineexampleblurbackground3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleblurbackground3 = /** @type {((inputs?: Refineexampleblurbackground3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleblurbackground3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleblurbackground3(inputs)
	return de_refineexampleblurbackground3(inputs)
});
export { refineexampleblurbackground3 as "refineExampleBlurBackground" }